import { render } from "./Tree.vue?vue&type=template&id=d2202d26"
import script from "./Tree.vue?vue&type=script&lang=js"
export * from "./Tree.vue?vue&type=script&lang=js"
script.render = render

export default script